import { ref, readonly } from 'vue';

const _isVisibleModalUpsell = ref(false);

export const useModalUpsell = () => {
  const isVisibleModalUpsell = readonly(_isVisibleModalUpsell);

  const openModalUpsell = () => {
    _isVisibleModalUpsell.value = true;
  };

  const closeModalUpsell = () => {
    _isVisibleModalUpsell.value = false;
  };

  return {
    isVisibleModalUpsell,
    openModalUpsell,
    closeModalUpsell,
  };
};
